



















































































import { Component, Vue } from "vue-property-decorator";
import { Catalogo, CatalogosService } from "@/services/catalogos.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import Confirm from "@/shared/components/confirm.vue";
import SelectFornecedor from "@/shared/components/select-fornecedor.vue";

import { inteiroNaoNegativo, required } from "@/shared/validators";
import { fileToBase64 } from "@/shared/utils/utils";

@Component({
  components: {
    Loading,
    Modal,
    SelectFornecedor,
    Confirm,
  },
})
export default class Manter extends Vue {
  catalogo: Catalogo | null = null;
  valid = false;
  loading = false;
  arquivoImagemDestaque: File | null = null;
  previewImagemDestaque: string | null = null;

  rules = {
    nome: [required()],
    descricao: [required()],
    fornecedores: [required()],
    prioridade: [inteiroNaoNegativo()],
  };

  get tituloManter(): string {
    if (this.catalogo) {
      return this.catalogo.idCatalogo == null
        ? "Novo Catálogo"
        : "Alterar Catálogo";
    }
    return "";
  }

  async salvarNotificacao() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (!form.validate() || !this.catalogo) {
      return;
    }

    this.normalizarPrioridade();

    this.loading = true;
    try {
      const imagemBase64 = this.arquivoImagemDestaque
        ? await fileToBase64(this.arquivoImagemDestaque)
        : "";
      await CatalogosService.manterCatalogo(this.catalogo, imagemBase64);
    } catch {
      // O interceptor do axios ja exibiu a mensagem do servidor; o form segue aberto para
      // a pessoa trocar o fornecedor recusado (holding nao pode ter catalogo).
      return;
    } finally {
      // Sem isto o modal fica preso no loader: com :loading ativo ele esconde o proprio
      // rodape, e o v-dialog persistent nao fecha por ESC nem por clique fora.
      this.loading = false;
    }

    return modal.close(true);
  }

  private normalizarPrioridade() {
    if (!this.catalogo) {
      return;
    }

    // v-model.number devolve "" (nao null) quando a pessoa apaga o campo, e "" nao chega
    // como null no int? Prioridade do servidor.
    const valor = this.catalogo.prioridade as unknown;
    this.catalogo.prioridade =
      valor === "" || valor === null || valor === undefined
        ? null
        : Number(valor);
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  gerarPreview() {
    if (!this.arquivoImagemDestaque) {
      this.previewImagemDestaque =
        this.catalogo?.imagemDestaqueCompleta ?? null;
      return;
    }

    this.previewImagemDestaque = URL.createObjectURL(
      this.arquivoImagemDestaque
    );
  }

  // A exclusao e imediata, nao espera o Salvar: ela so existe para catalogo ja gravado, e o
  // arquivo no S3 precisa sair junto do campo.
  async excluirImagem() {
    if (!this.catalogo?.idCatalogo) {
      return;
    }

    const modalConfirm = this.$refs.confirm as Confirm;
    const confirmado = await modalConfirm.open(
      "Excluir imagem de destaque",
      `Deseja realmente excluir a imagem de destaque do catálogo ${this.catalogo.nome}?`
    );

    if (!confirmado) {
      return;
    }

    this.loading = true;
    try {
      await CatalogosService.excluirImagemDestaque(this.catalogo.idCatalogo);
    } finally {
      this.loading = false;
    }

    this.catalogo.imagemDestaque = null;
    this.catalogo.imagemDestaqueCompleta = null;
    this.arquivoImagemDestaque = null;
    this.previewImagemDestaque = null;
  }

  private limparImagemDestaque() {
    this.arquivoImagemDestaque = null;
    this.previewImagemDestaque = null;
  }

  public async editarCatalogo(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.limparImagemDestaque();

    this.loading = true;
    try {
      this.catalogo = await CatalogosService.obterCatalogo(id);
      this.previewImagemDestaque =
        this.catalogo?.imagemDestaqueCompleta ?? null;
    } catch {
      this.fechar();
    } finally {
      this.loading = false;
    }

    return p;
  }

  public async novoCatalogo() {
    const modal = this.$refs.modal as Modal;

    this.catalogo = {} as Catalogo;
    this.limparImagemDestaque();

    return modal.open();
  }
}
